<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <SharedCard :class="b()">
    <div :class="b('header')">
      <SharedBack @click="handleBack" />

      <div :class="b('header-content')">
        <h3 :class="b('title')">
          {{ $t("Верификация информации о компании") }}
        </h3>
        <p :class="b('subtitle')">
          {{ $t("Пройдите три блока — порядок любой, данные сохраняются") }}
        </p>
      </div>
    </div>

    <div :class="b('content')">
      <div :class="b('list')">
        <button
          :class="b('item', { padding: item.isPadding })"
          v-for="item in displayedList"
          :key="item.id"
          :disabled="item.isDisabled"
          @click="handleContinue(item)"
        >
          <span
            :class="b('item-icon', { success: item.isSuccess })"
            v-html="item.icon"
          ></span>

          <div :class="b('item-info')">
            <h4 :class="b('item-title')">
              {{ $t(item.title) }}
            </h4>

            <p :class="b('item-label')">
              {{ $t(item.label) }}
            </p>
          </div>

          <span :class="b('item-chevron')" v-html="displayedSvg.chevron"></span>
        </button>
      </div>

      <div :class="b('verification-block')">
        <UIButton
          :class="b('verification')"
          :label="displayedVerificationLabel"
          view="main"
          :disabled="isVerificationDisabled"
          @click="handleVerification"
        />
        <p
          v-if="isVerificationDisabled && !isReadonly"
          :class="b('verification-hint')"
        >
          {{
            $t(
              "Кнопка станет активной, когда все обязательные блоки будут отмечены галочкой"
            )
          }}
        </p>
      </div>
    </div>
  </SharedCard>
</template>
